/**
 * Turns custom_fields from the API into a simple object we can use in the app.
 *
 * The API sometimes sends custom_fields as an array of strings like:
 *   ["[Public_Job", "true]", "[Job_Level", "P5 - Principal]"]
 * (key and value are separate items; keys have a leading "[", values have a trailing "]".)
 *
 * We convert that into an object like:
 *   { Public_Job: { label: "Public_Job", value: "true" }, Job_Level: { label: "Job_Level", value: "P5 - Principal" } }
 * @param raw
 */
export const normalizeCustomFields = (raw) => {
  if (!raw) return {};

  const numberOfCustomFieldPairs = Math.floor(raw.length / 2);
  const entries = Array.from({ length: numberOfCustomFieldPairs }, (_, index) => {
    const keyFromApi = String(raw[index * 2]);
    const valueFromApi = String(raw[index * 2 + 1]);

    // Remove the leading "[" and trailing "]" from the key and value.
    const key = keyFromApi.replace(/^\[/, '').trim();
    const value = valueFromApi.replace(/\]$/, '').trim();

    return [key, { label: key, value }];
  }).filter(([key]) => key);

  return Object.fromEntries(entries);
};
